import React from 'react';

export function LimitContentWidthBoldColumnFormatter(cellContent) {
  return (
    <div title={cellContent} className="text-dark-75 font-weight-bolder d-block font-size-lg text-nowrap limited-content-width-column">
      {cellContent}
    </div>
  );
}
